import { render, staticRenderFns } from "./VabMenuItem.vue?vue&type=template&id=3da075ab&scoped=true"
import script from "./VabMenuItem.vue?vue&type=script&lang=js"
export * from "./VabMenuItem.vue?vue&type=script&lang=js"
import style0 from "./VabMenuItem.vue?vue&type=style&index=0&id=3da075ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da075ab",
  null
  
)

export default component.exports